export const es = {
  clipboard: {
    successCopied: "Copiado al portapapeles",
  },
  notification: {
    title: "Configuración de notificaciones",
    emailNotifications: "Notificaciones por correo",
    marketingEmails: "Correos de marketing"
  },
  safety: {
    title: "Verificación KYC",
    subtitle: "Complete la verificación para acceder a todas las funciones de la plataforma.",
    bannerTitle: "Verificación vía Reown",
    bannerText1: "Su cuenta utiliza autenticación de Reown.",
    bannerText2: "Para subir su nivel de verificación, vaya a la sección \"Verificación\".",
    standardLevel: "Nivel Estándar",
    standardDesc: "Confirmación de correo y número de teléfono.",
    enhancedLevel: "Nivel Avanzado",
    enhancedDesc: "Envío de datos del pasaporte.",
    professionalLevel: "Nivel Profesional",
    professionalDesc: "Prueba de domicilio.",
    completed: "Completado",
    inProgress: "En progreso",
    start: "Comenzar"
  },
  referral: {
    title: "Programa de referidos",
    description: "¡Invite a sus amigos y gane recompensas!",
    subtitle: "Su enlace de referido",
    yourReferrals: "Sus referidos",
    statsElements: ["Referidos totales", "Activos", "Inversiones totales", "Sus ganancias"],
    yourLevel: {
      topTitle: "Su nivel",
      toNextLevel: "Siguiente nivel:",
      activeReferralsOr: "referidos activos O",
      toLvl: "hasta"
    },
    referrer: {
      title: "¿Tiene un código de referido? Ingréselo aquí",
      enterCode: "Introducir código",
      check: "Comprobar"
    },
    confirm: "Confirmar",
    changeRefCode: "Cambiar código de referido",
    newCode: "nuevo código",
    enterNewCode: "Ingresa tu nuevo código",
    minMaxChars: "Mínimo 6 caracteres, máximo 8"
  },
  referralNew: {
    code: {
      title: "¿Tienes un código de referido?",
      description: "Introdúcelo abajo para conectarte\ncon tu referente.",
      input: "Código de referido",
      button: "Verificar",
      title_CodeVerified: "Código verificado",
      description_CodeVerified: "Ahora puedes invitar a otros y ganar recompensas.",
      youInviter: "tu referente"
    },
    details: {
      title: "Tus detalles de referido",
      description: "Invita a tus amigos a Zenex y gana bonificaciones.",
      sendThis: "Envía este enlace a tu amigo",
      orShare: "O comparte tu código manual",
      members: "miembros",
      paidOut: "pagado en 2025",
      alreadyEarning: "ya ganan con nosotros"
    },
    program: {
      button: "Más información",
      cards: {
        title: "Niveles mensuales",
        subtitle: "Programa de socios",
        description: "Gana con el volumen de tarjetas de tus referidos",
        how: "Cómo funciona",
        elements: [
          "Volumen total de recargas de todos los referidos por mes calendario",
          "El estado se recalcula el 1º de cada mes",
          "La comisión se paga según tu nivel actual"
        ]
      },
      invest: {
        title: "Sistema acumulativo",
        subtitle: "Programa de referidos",
        description: "Gana con las inversiones de tus amigos",
        how: "Cómo ganar",
        elements: [
          "Invita a un amigo a unirse a Zenex Invest",
          "Comienza a invertir en Zenex Pools",
          "Recibes recompensas de sus ganancias"
        ]
      }
    }
  },
  innerReferral: {
    title: "Sistema de Referidos \n Zenex Invest",
    statistic: {
      pattern: " este mes",
      status: {
        title: "Estado actual",
        subtitle: "Tus bonificaciones: ",
        description: "{depositBonus} del depósito y {incomeBonus} de las ganancias",
        labelLeft: "Hasta {level}",
        labelCenter: "{count, plural, one {# referido} other {# referidos}} o",
        labelRight: ""
      },
      referrals: {
        title: "Referidos activos",
        description: "+{count} nuevos",
      },
      deposit: {
        title: "Monto total de depósitos",
        description: "+{count}$"
      },
      income: {
        title: "Mis ingresos",
        description: "~{count}$",
        pattern: "/por mes",
      },
    },
    link: {
      title: "Aumenta tu nivel y gana más",
      sendThis: "Envía este enlace a un amigo",
      orShare: "O comparte el código para ingreso manual",
    },
    tabs: {
      levels: "Sistema de niveles",
      history: "Historial de pagos",
      referrals: "Lista de referidos",
    },
    faq: {
      kicker: "FAQ",
      title: "Cómo funciona el sistema de referidos",
      questions: [
        "¿Dónde se acreditan mis recompensas de referidos y cómo puedo retirarlas?",
        "¿El enlace de referido es diferente para cada producto o existe uno único?",
        "Invité a un amigo que invirtió en el pool RevShare. ¿Cuándo recibiré mi recompensa?",
        "¿Cómo puedo subir de nivel en el programa de referidos?",
      ],
      answers: [
        "Tus recompensas se acreditan directamente en la billetera conectada a tu cuenta de Zenex Hub, y puedes retirarlas a cualquier billetera externa.",
        "Existe un único enlace de referidos para todos los productos de Zenex. Compartiendo un solo enlace, recibes recompensas por cada producto que utilice tu referido.",
        "Las recompensas se acreditan a partir del mes siguiente. Recibes una parte de su depósito (recompensa única) y una parte de sus ganancias (recompensas mensuales recurrentes).",
        "Tu nivel aumenta cuando el volumen total de inversión de tus referidos alcanza el requisito para el siguiente nivel. El nuevo nivel se aplica al inicio del próximo mes calendario.",
      ],
    },
    levels: {
      title: "Sistema de niveles y recompensas",
      description: "El nivel se determina por el mejor indicador: número de referidos activos o monto total de sus inversiones",
      status: {
        received: "Obtenido",
        current: "Nivel actual",
        blocked: "Bloqueado",
        more: "Faltan {count, plural, one {# referido} other {# referidos}}",
      },
      level: {
        associate: "Associate",
        partner: "Partner",
        executive: "Executive",
        elite: "Elite",
        ambassador: "Ambassador",
      },
      rows: {
        referrals: "Referidos",
        total: "Monto total de depósitos",
        incomeDeposit: "Ingresos del depósito",
        incomeStable: "Ingresos del Stable Pool",
        incomeGrowth: "Ingresos del Growth Pool",
      },
    },
    filters: {
      label: "Ordenar por",
      dateAscending: "Fecha: ascendente",
      dateDescending: "Fecha: descendente",
      incomeAscending: "Ingresos: ascendente",
      incomeDescending: "Ingresos: descendente",
    },
    pagination: "Página {current} de {total}",
    incomeHistory: {
      title: "Ingresos e historial de pagos",
      column: {
        date: "Fecha",
        user: "Referido",
        pool: "Pool",
        incomePercent: "Ganancia",
        income: "Monto",
      },
    },
    referrals: {
      title: "Mis referidos",
      column: {
        user: "Referido",
        pool: "Pool",
        deposit: "Invertido",
        profit: "Ganancia del referido",
        earning: "Mis ingresos",
      },
    },
  },
  quest: {
    title: "Tareas y logros",
    subtitle: "¡Complete tareas para ganar bonos y recompensas!",
    subscribe: "¡Suscríbase a nuestro Instagram!",
    follow: "¡Síganos en X!",
    join: "¡Únase a nuestro Telegram!",
    done: "Hecho",
    complete: "Completar"
  },
  account: {
    title: "Cuenta",
    fields: {
      name: "Nombre",
      nickname: "Apodo",
      email: "Email",
      bio: "Bio"
    },
    verify: "Verificar",
    confirmChanges: "Confirmar cambios",
    updateSuccess: "Cambios guardados correctamente",
    updateError: "No se pudieron guardar los cambios",
    linksTitle: "Vincule sus cuentas para funciones adicionales",
    connectX: "Conectar X",
    connectTelegram: "Conectar Telegram",
    connectInstagram: "Conectar Instagram",
    logout: "Cerrar sesión",
    emailDialog: {
      title: "Verifique su correo",
      description1: "Hemos enviado un código de 6 dígitos a {email}",
      description2: "Introdúzcalo abajo para completar su registro y acceder a todas las funciones de Zenex Hub.",
      confirmBtn: "Confirmar correo",
      cantFind: "¿No encuentra el correo? Revise su carpeta de Spam",
      resend: "o solicite uno nuevo",
      sentPrefix: "Hemos enviado un código de 6 dígitos a"
    },
    cancel: "Cancelar",
    saveChanges: "Guardar cambios",
    selectNewAvatar: "Seleccionar nuevo avatar",
    unsavedChanges: {
      title: "Cambios sin guardar",
      subtitle: "¿Tienes cambios sin guardar. ¿Descartarlos y salir?"
    }
  },
  sell: {
    to: "Retirar a",
    select: "Seleccionar token",
    button: "Retirar",
    loading: "Retirando…"
  },
  errors: {
    insufficientFunds: "Fondos insuficientes",
    maxLimit: "El límite máximo es {value}$",
    serviceUnavailable: "Servicio no disponible, por favor intente más tarde",
  },
  card: {
    title: {
      white: "— ¡La nueva era de pagos con tarjeta comienza aquí!",
      green: "por Zenex",
      yellow: "NS.Cards"
    },
    description:
      "Cero comisiones por transacción, restricciones MCC, límites de gasto hasta $100,000 — todo esto y más con la tarjeta Zenex.",
    button: "Obtener tarjeta",
    columns: {
      left: {
        title: {
          white: "NS.CARDS para\n",
          green: "Mediabuyers"
        },
        items: [
          "Recarga con cripto o fiat desde 2,5%",
          "Sin KYC",
          "0% de comisiones en MCC relacionados con ADS"
        ],
        cta: "Obtener la tarjeta"
      },
      right: {
        title: {
          white: "NS.CARDS",
          yellow: "Tarjeta Wild sin límites"
        },
        items: [
          "Recarga con cripto o fiat desde 2,5%",
          "Sin límites MCC",
          "Apple Pay/Google Pay + opciones físicas",
          "$100k/mes para tus transacciones"
        ],
        cta: "Obtener la tarjeta"
      }
    }
  },
  investHome: {
    title: "Pools de RevShare",
    description:
      "El primer RWA de iGaming — Financia tráfico de casino y gana un % del GGR de la plataforma uniéndote a los pools de RevShare de ZNX para rendimientos conservadores o de alto rendimiento.",
    button: "Zenex Invest"
  },
  invest: {
    title: "Pools de Tráfico",
    description:
      "Participación en NGR del tráfico de White Rabbit Casino (Kazajistán) - whiterabbit.casino\n" +
      "Compramos tráfico de alta calidad, lo convertimos en depósitos y compartimos la ganancia.",
    button: "Seguir actualizaciones",
    dashboardTitle: "Panel de inversión",
    secondPageDescription1: "Gana GGR de plataformas de casino.",
    secondPageDescription2: "Compramos tráfico de alta calidad, lo convertimos en depósitos y compartimos la ganancia.",
    dashboardDescription: "Administra tus inversiones y sigue el rendimiento de todos los pools.",
    investFirstRowElements: [
      "años de experiencia", "Reg2Dep", "ROI mensual", "de GGR = NGR"
    ],
    poolsTitle: "Pools disponibles",
    pools: ["miembros", "tipos de pools", "meses", "ZNX\n" + "límite total"],
    poolsOffers: {
      titlesStable: ["Garantía de retorno del 100% del capital", "34-42,5% del GGR", "Pagos en USDC"],
      titlesGrowth: ["Máximo upside del ZNX", "8,5-12,75% del GGR", "Pagos en USDC"],
      whyHint: {
        safeTitle: "¿Por qué un % de GGR más alto?",
        safeText: "Adquirimos tus ZNX al valor USD actual. El porcentaje es más alto porque\ncompramos tus tokens y compartimos el máximo de beneficios. El retorno garantizado\nde tu inversión en equivalente USD mantiene tus fondos\nseguros.",
        growthTitle: "¿Por qué un % de GGR más bajo?",
        growthText: "Durante 12 meses, gestionamos tus tokens ZNX y nos aseguramos de que recuperes toda tu inversión al final del plazo.\nEl porcentaje es más bajo porque conservas la propiedad y el potencial de crecimiento del token"
      },
      amountStaked: "Cantidad en staking"
    },
    poolsOffersRow: {
      payoutsStable: ["34% del GGR", "38,25% del GGR", "42,5% del GGR"],
      payoutsGrowth: ["8,5% del GGR", "10,625% del GGR", "12,75% del GGR"]
    },
    poolButton: "Entrar al pool",
    nrgComeFrom: {
      title: "¿De dónde proviene el NGR para los pagos?",
      nrgElements: {
        titles: ["GGR de jugadores", "Menos 15%", "= NGR", "A los participantes del pool"],
        subTitles: ["Gross Gaming Revenue", "Gastos administrativos\n" + "del casino", "Net Gaming Revenue", "Según el nivel\n" + "y tipo de pool"]
      },
      description: "Ejemplo: GGR $100k → NGR $85k → Los participantes reciben entre $8.5k y $42.5k, según el pool y el nivel."
    },
    howItWorks: {
      title: "¿Cómo funciona?",
      elements: {
        titles: ["Agrupación de tokens ZNX", "Adquisición de tráfico", "Generación de ganancias", "Pagos mensuales", "Devolución de la inversión inicial"],
        descriptions: [
          "Los participantes del pool depositan tokens ZNX\n" + "hasta un límite de 230k tokens/mes",
          "Compramos tráfico de alta calidad mediante el modelo CPA\n" + "para White Rabbit Casino",
          "El casino gana GGR\n= ‘pérdidas’ de jugadores – ‘ganancias’ de jugadores",
          "Los participantes del pool reciben un % del GGR\nen USDC según el nivel y tipo de pool cada mes",
          "Los tokens que colocaste en el pool\nse devolverán completamente después de 12 meses"
        ]
      }
    },
    faq: {
      title: "Preguntas frecuentes",
      questions: [
        "¿Qué son los Zenex RevShare Pools?",
        "¿Cómo se realizan los pagos?",
        "¿Cómo se calcula mi pago mensual?",
        "¿Puedo salir del pool antes de tiempo?",
        "¿Qué sucede si el pool no alcanza el monto objetivo?",
        "¿Cuándo se devolverán mis ZNX?",
      ],
      answers: [
        "Zenex RevShare Pools es una tokenización RWA de un negocio real de casino. Adquieres tokens ZNX, los colocas en pools de adquisición de tráfico para <span>whiterabbit.casino</span> y recibes un porcentaje fijo del Gross Gaming Revenue (GGR) cada mes durante 12 meses.",
        "Los pagos se realizan mensualmente en USDC el día 15 de cada mes durante 12 meses. Los fondos llegan a tu balance en ZNX Hub y puedes retirarlos inmediatamente o reinvertirlos.",
        "Tu pago depende de dos factores: tu participación en el pool y el rendimiento mensual del GGR del casino.",
        "No, no es posible salir antes de tiempo. Los fondos quedan bloqueados en un smart contract durante 12 meses. Esto nos permite planificar campañas de marketing y garantizar retornos estables.",
        "El pool se lanzará de todos modos. Las proporciones de distribución de ganancias se determinarán después de realizar las compras mensuales de tráfico.",
        "El 100% de los tokens ZNX que colocaste en el pool serán devueltos automáticamente después de 12 meses.",
      ],
    },
    betshops: {
      title: "Betshops"
    },
    questions: {
      title: "¿Aún tienes preguntas?",
      subtitle: "¡Contacta ahora con nuestro equipo para encontrar el mejor pool para tus objetivos!",
      button: "Contactar"
    },
    moreInfo: {
      title: "Más información sobre los pools Zenex RevShare",
      telegram: "Nuestro Telegram",
      instagram: "Nuestro Instagram",
      linkedin: "Nuestro LinkedIn"
    },
    payoutVariations: {
      title: "Cómo pueden variar los pagos",
      inputLabel: "Introduce el monto de la inversión",
      weakLabel: "Escenario débil",
      strongLabel: "Escenario fuerte",
      months: [
        "Hoy",
        "Ene 2025",
        "Abr 2025",
        "Jul 2025",
        "Oct 2025",
        "Ene 2026",
        "Abr 2026",
        "Jul 2026",
        "Oct 2026",
        "Dic 2026"
      ],
      weakScenarioLabel: "Rendimiento total en escenario débil (sin crecimiento de precio)",
      strongScenarioLabel: "Rendimiento total en escenario fuerte (150% de crecimiento de precio)",
      disclaimer: "Los cálculos se basan en el rendimiento histórico y no son pronósticos."
    },
    header: {
      smallTitle: "Pools de RevShare de Zenex",
      mainHeading: "Aprovecha los ingresos de casino sin costes operativos ni riesgos",
      description: "Compramos tráfico de alta calidad para casinos, lo convertimos en depósitos y compartimos las ganancias",
      ctaStartEarning: "Empezar a ganar",
      ctaViewStatistics: "Ver estadísticas",
      stats: {
        item1: {
          value: "60 meses",
          description: {
            prefix: "Rentabilidad comprobada de",
            link: "White Rabbit Casino"
          }
        },
        item2: {
          value: "40%+",
          description: "Conversión reg-a-dep líder en la industria"
        },
        item3: {
          value: "Transparente",
          description: "Informes de rendimiento y datos mensuales"
        },
        item4: {
          value: "Dos fuentes de ingresos",
          description: "Pagos mensuales en USDC y devolución total de tu ZNX con potencial alcista"
        }
      }
    },
    enterToPoolDialog: {
      title: "Cantidad total de ZNX",
      availableBalance: "Saldo disponible",
      stakedInPool: "En stake en este pool",
      buttonTopUp: "Recargar balance",
      buttonEnterPool: "Entrar al pool",
      choosePlan: "Elige tu plan",
      inputLabel: "Introduce cantidad de ZNX",
      inputMessages: {
        exceedsBalance: "Excede el balance",
        increase: {
          toIncrease: "Para aumentar tu",
          addAdditional: "agrega adicional",
          stable: {
            toBasic: "GGR a 34%",
            toAdvanced: "GGR a 38,25%",
            toPremium: "GGR a 42,5%"
          },
          growth: {
            toBasic: "GGR a 8,5%",
            toAdvanced: "GGR a 10,625%",
            toPremium: "GGR a 12,75%"
          }
        }
      }
    },
    myActivePools: {
      title: "Mis Pools Activos",
      myActivePoolElements: ["En staking", "Plan\n" + "Actual", "GGR"],
      myActivePoolElementsV2: ["Tamaño del pool", "En stake", "Plan actual", "GGR", "Total ganado"],
      growUp: "¡Mejora tu plan para aumentar ganancias!",
      missing: "Faltan",
      buttonStats: "Ver estadísticas",
      buttonAddZNX: "Agregar ZNX",
      buttonClaim: "Reclamar",
      months: {
        january: "Enero",
        february: "Febrero",
        march: "Marzo",
        april: "Abril",
        may: "Mayo",
        june: "Junio",
        july: "Julio",
        august: "Agosto",
        september: "Septiembre",
        october: "Octubre",
        november: "Noviembre",
        december: "Diciembre"
      },
      status: {
        active: "Activo hasta {date}",
        prefunding: "Pre-financiación",
        closed: "Cerrado",
      },
      upgrade: {
        label: "Mejora tu plan a",
        boost: "Aumenta las ganancias hasta {percent}% del GGR ({ggr})",
        missing: "Falta: ",
      }
    },
    stats: {
      title: "Panel de Analítica de White Rabbit",
      description: "Analítica Operativa",
      claimButton: "Reclamar",
      chartPerios: ["1d", "1s", "1m"],
      chartLine: "Dinámica del GGR",
      barLine: "Dinámica de Jugadores Activos",
      addZnx: "Añadir ZNX",
      spent: "Gastado",
      ftdLabel: "FTD\n(Primeros depositantes)",
      cpaLabel: "CPA\n(Coste por FTD)",
      averageDeposit: "Depósito medio",
      ggrThisMonth: "GGR este mes",
      totalGgr: "GGR total",
      day: "Día {day}",
      activity: {
        title: "Estado de actividad del pool",
          status: {
          active: "Activo hasta {date}",
            prefunding: "Pre-financiación",
            closed: "Cerrado",
            traffic: "Adquisición de tráfico"
        },
      },
      prefunding: {
        goal: "Objetivo de financiación",
          raised: "Recaudado",
          investors: "Inversores",
          launch: "Lanzamiento en"
      },
      stake: {
        label: "Mi participación",
          elements: ["En stake", "Plan actual", "GGR", "Próxima fecha de pago", "Total ganado"],
      },
      upgrade: {
        label: "Mejora tu plan a",
          boost: "Aumenta las ganancias hasta {percent}% del GGR ({ggr})",
          missing: "Falta: ",
      },
      placeholderPool: {
        title: "Las estadísticas aparecerán después del lanzamiento del pool",
          description: "¡Invierte ahora para obtener acceso anticipado a los datos de rendimiento!",
          action: "Unirse al pool",
      },
      myPayouts: {
        title: "Mis pagos",
          action: "Reclamar",
          pool: "Pago de {pool} de {month}",
        stable: "Stable Pool",
          growth: "Growth Pool",
          eta: {
          days: "{count, plural, one {# día} other {# días}}",
            hours: "{count, plural, one {# hora} other {# horas}}",
        },
      },
      months: {
        january: "Enero",
        february: "Febrero",
        march: "Marzo",
        april: "Abril",
        may: "Mayo",
        june: "Junio",
        july: "Julio",
        august: "Agosto",
        september: "Septiembre",
        october: "Octubre",
        november: "Noviembre",
        december: "Diciembre"
      },
      yourPayouts: "Tus"
    },
    transparency: {
      title: "Transparencia",
      lastUpdated: "Última actualización:",
      dataSource: "Fuente de datos:",
      crossGamingRevenue: "Gross Gaming Revenue",
      adminFee: "Tarifa Administrativa (15%)",
      netGamingRevenue: "Net Gaming Revenue",
      totalDeposits: "Depósitos Totales",
      playersCount: "Número de Jugadores"
    },
    overview: {
      title: "Resumen Personal de Inversión",
      totalInvested: "Total invertido",
      totalEarned: "Total ganado",
      nextPayout: "Próximo pago",
      poolShare: "Tu participación en el pool:",
      roi: "ROI:",
      paymentDate: "Fecha de pago:",
      poolMetrics: "Métricas del Pool",
      poolSize: "Tamaño del Pool",
      investors: "Inversores",
      staked: "En staking",
      players: "Jugadores"
    },
    totalStaked: {
      title: "Total en Staking en Pools",
      button: "Invertir en Pools",
      stable: "stable pool",
      growth: "growth pool",
      totalFormat: "{total}/{max} ZNX"
    },
    whiteRabbitPromo: {
      title: "Estadísticas del Pool White Rabbit",
      subtitle: "Mira los números, calcula tus ganancias, únete ahora",
      button: "Abrir estadísticas"
    },
    poolMetrics: {
      title: "Métricas del Pool",
      metricsElements: ["Tamaño del Pool", "Inversores", "En staking", "Jugadores"]
    },
    growthDetails: {
      title: "Zenex Growth Pool",
      progress: {
        label: "Progreso del pool"
      },
      metrics: {
        ggrShareLabel: "Participación del GGR del casino",
        lockPeriodLabel: "Periodo de bloqueo",
        lockPeriodValue: "12 meses",
        payoutsUSDCLabel: "Pagos en USDC",
        payoutsFrequencyValueMonthly: "Mensual",
        returnedAfterLabel: "Devuelto después de 12 meses",
        returnedAfterValue: "100% ZNX"
      },
      tooltips: {
        tierShare: "Tu participación en el casino depende del nivel",
        payoutsDepend: "Los pagos dependen del GGR mensual del casino",
        noEarlyWithdrawal: "No hay retiro anticipado",
        znxGrowth: "Si ZNX sube, tu rendimiento final también crece"
      },
      tier: {
        depositLabel: "Depósito:",
        note: "El nivel se determina automáticamente por el monto del depósito"
      },
      button: {
        closed: "La recaudación está cerrada"
      }
    },
    joinPool: "Unirse al pool",
    poolsPromoTitle: "Las estadísticas aparecerán tras el lanzamiento del pool",
    poolsPromoSubtitle: "¡Invierte ahora para tener acceso anticipado a los datos de rendimiento!"
  },
  buy: {
    currency: "Moneda",
    network: "Red",
    sum: "Cantidad",
    min: "Mínimo",
    max: "Máximo",
    loading: "Cargando…",
    buy: "Comprar",
    approve: "Transferir {amount} {currency} a la dirección:"
  },
  claim: {
    have: "Tienes",
    available: "tokens disponibles",
    description:
      "Haz clic en el botón \"Reclamar\" para añadirlos al saldo de tu cuenta.",
    button: "Reclamar",
    check: "Comprobar",
    total: "Tu puntuación total",
    tooltip: "Campo opcional",
    notice: {
      white: "Introduce el código de bono para obtener",
      green: "x2 tokens ZNX."
    },
    errors: {
      invalidCode: "Código inválido",
      codeExpired: "El código ha expirado.",
      codeRequired: "El código es obligatorio."
    },
    optional: "Campo opcional"
  },
  page: {
    title: {
      green: "Bienvenido a",
      yellow: "Zenex Hub!"
    },
    descriptions1:
      "¡Gracias por creer en nosotros y querer crecer con nosotros!",
    descriptions2:
      "Estamos en la fase final de pruebas y pronto presentaremos toda nuestra funcionalidad.",
    descriptions3: "Juega ahora para reclamar tus",
    descriptions4: "tokens gratis",
    descriptions5: "— ¡no te lo pierdas!",
    buttons: {
      play: "Jugar Treasure Hunt",
      get: "Obtener ZNX"
    },
    notice: "Esta oferta está disponible solo por tiempo limitado.",
    back: "Atrás",
    tabs: {
      account: "Cuenta",
      safety: "Seguridad",
      notifications: "Notificaciones",
      referrals: "Referencias",
      quests: "Misiones"
    }

  },
  balance: {
    title: "Tus colecciones NFT"
  },
  header: {
    title: {
      profile: "Configuración de Perfil",
      reshare:"Investissements"
    },
    welcome: "¡Bienvenido {username}!",
    welcome_empty: "¡Bienvenido!",
    button: {
      logout: "Cerrar sesión"
    },
    labels: {
      address: "Dirección:",
      caipAddress: "Dirección CAIP:",
      status: "Estado:"
    },
    dropdown: {
      supportChat: "Chat de soporte",
      documents: "Documentos",
      legalDocuments: "Documentos legales",
      termsOfUse: "Términos de uso",
      privacyPolicy: "Política de privacidad",
      cookiesPolicy: "Política de cookies",
      buyZNXwithCrypto: "ZNX con criptomonedas",
      buyZNXonDEX: "ZNX en DEX",
      buyZNXwithCard: "ZNX con tarjeta"
    }
  },
  login: {
    title: {
      green: "Bienvenido a",
      white: "Zenex Hub!"
    },
    button: "Conectar"
  },
  plans: {
    title: "Programas de Acceso de Inversión de Zenex",
    welcome: "¡Bienvenido {username}!",
    welcome_empty: "¡Bienvenido!",
    cards: {
      silver: {
        title: "Nivel Silver",
        subtitle: "Inversor Temprano",
        items: [
          "1.000 plazas",
          "ZNX Play: Staking ×1,5 (6 meses)",
          "ZNX Arena: 5 cartas estándar + 1 dorada",
          "ZNX Invest: Acceso exclusivo a pools",
          "Bono: 850 ZNX"
        ]
      },
      gold: {
        title: "Nivel Gold",
        subtitle: "Socio Estratégico",
        items: [
          "200 plazas",
          "ZNX Play: Staking ×2 (12 meses)",
          "ZNX Arena: 8 cartas estándar + 2 doradas",
          "ZNX Invest: +10% de rendimiento en pools",
          "Bono: 4.200 ZNX"
        ]
      },
      platinum: {
        title: "Nivel Platinum",
        subtitle: "Inversor VIP",
        items: [
          "50 plazas",
          "ZNX Play: Staking ×3 (12 meses)",
          "ZNX Arena: 10 cartas estándar + 3 doradas",
          "ZNX Invest: +20% de rendimiento en pools",
          "Chat privado insider",
          "Bono: 12.500 ZNX"
        ]
      },
      diamond: {
        title: "Nivel Diamond",
        subtitle: "Socio Fundador",
        items: [
          "20 plazas",
          "ZNX Play: Staking ×4 (12 meses)",
          "ZNX Arena: 10 cartas estándar + 5 doradas",
          "ZNX Invest: +30% de rendimiento + asignaciones garantizadas",
          "Chat privado + influencia en la plataforma",
          "Mención en el Salón de la Fama",
          "Bono: 12.500 ZNX"
        ]
      }
    },
    button: "Comprar",
    available: "Posiciones disponibles",
    benefits: "Beneficios"
  },
  opportunities: {
    cards: {
      play: {
        title: "ZNX Play",
        description: "Mantén ZNX, gana recompensas — sin esfuerzo."
      },
      invest: {
        title: "ZNX Invest",
        description:
          "Gana con el primer RWA de iGaming desde solo 50 ZNX"
      },
      cases: {
        title: "Cases & Chests",
        description: "Abre cases para recompensas aleatorias, potenciadores o ventajas."
      },
      arena: {
        title: "ZNX Arena",
        description:
          "Obtén beneficios de promotores compitiendo por clientes en un reality show de negocios."
      }
    },
    button: "Muy pronto",
    buttonOpen: "Abrir"
  },
  meta: {
    title: "Español"
  },
  cards: {
    transactions: {
      title: 'Últimas transacciones',
      column: {
        card: "Tarjeta",
        date: "Fecha",
        details: "Detalles",
        status: "Estado",
        amount: "Importe",
        fee: "Comisión"
      },
      status: {
        RESERVED: "Reservado",
        UNRESERVED: "Liberado",
        TRANSFERRED: "Transferido",
        REFUNDED: "Reembolsado",
        REFUNDED_PARTIAL: "Reembolso parcial",
        FAILED: "Fallido",
        LOADED: "Cargado",
        UNLOADED: "Descargado",
        COMPLETED: "Completado"
      }
    },
    myCards: {
      title: "Mis tarjetas",
      goToSite: "Ir a NS.Cards",
      balance: 'Saldo',
      buyNewCards: "Comprar nueva tarjeta",
      cardRedirect: "Serás redirigido a un servicio externo para completar tu compra",
      topUpZnx: "Recargar con ZNX",
      confirmTopUp: "Confirmar recarga",
      topUpAmount: 'Importe de recarga',
      viewAllCards: 'Ver todas las tarjetas',
      hideCards: 'Ocultar tarjetas',
      loading: 'Cargando',
      loadingAddress: 'Cargando dirección de depósito...',
    }
  },
  wallet: {
    title: {
      main: "Billetera",
      mainNew: "Billetera no custodial",
      cards: "Zenex Cards",
      balance: "Activos Totales",
      transaction: "Historial de Transacciones",
      calendar: "Calendario de Pagos",
      payments: "Próximos Pagos"
    },
    availableBalance: "Saldo disponible",
    chooseAssets: "Elige un activo",
    walletNetworkDeposit: "Red de depósito",
    walletNetworkWithdraw: "Red de retiro",
    address: "Dirección",
    destinationAddress: "Dirección de destino",
    enterAddress: "Introducir dirección",
    pasteWalletAddress: "Pega la dirección de la billetera",
    enterAmount: "Ingrese el monto",
    withdrawAmount: "Cantidad a retirar",
    minimumWithdrawAmount: "Cantidad mínima de retiro: {value}",
    transactionDetails: "Detalles de la transacción",
    transactionFee: "Comisión de transacción",
    insufficientFundsForFee: "Fondos insuficientes para cubrir la comisión de la transacción.",
    missing: "Falta: {value}",
    addSol: "Agregar SOL",
    paste: "Pegar",
    max: "Máx",
    doubleCheckWithdraw: "¡Por favor revisa dos veces la dirección de retiro!",
    doubleCheckDeposit: "¡Por favor revisa dos veces la dirección de depósito!",
    sendingFundsToWrong: "Enviar fondos a una dirección incorrecta puede resultar en la pérdida irreversible\n" + "de tu criptomoneda.",
    theProcedureUpTo48Hours: "¡El procedimiento puede tardar entre 1 y 2 minutos!",
    theProcedureUpTo30min: "El procedimiento puede tardar hasta 30 minutos",
    exRate: "Tipo de cambio",
    swap: "Confirmar",
    sell: "Vender",
    receive: "Recibir",
    send: "Enviar",
    mainTitle: "Intercambio",
    amount: "Cantidad",
    toSwap: "Intercambiar",
    searchTokens: "Buscar cualquier token",
    selectCurrency: "Seleccionar moneda",
    selectCurrencyOrNetwork: "Seleccionar moneda o red",
    selectToken: "Seleccionar token",
    selectNetwork: "Seleccionar red",
    continueInWallet: "Continuar en la billetera",
    swapReview: "Revisa los detalles de la transacción\n" + "antes de confirmar!",
    depositAddress: "Dirección de depósito",
    walletDepositLoading: "Por favor espera, se está generando tu dirección de depósito...",
    walletSwapDepositLoading: "Por favor espera mientras se inicia tu operación de intercambio...",
    swapPage: {
      youSend: "Envías",
      youReceive: "Recibes",
      swapMinDeposit: "Depósito mínimo",
      fee: "Comisión",
      feeWithdraw: "Comisión de retiro",
      finish: "Finalizar",
      swapSuccess: "Intercambio completado con éxito",
      swapError: "El intercambio falló. Inténtalo de nuevo."
    },
    balanceButtons: {
      deposit: "Depositar",
      withdraw: "Retirar",
      exchange: "Intercambiar",
      buyZNX: "Comprar ZNX"
    },
    transactionHistory: {
      type: "Tipo",
      total: "Total",
      info: "Info",
      date: "Fecha",
      status: "Estado"
    }
  },
  paymentProcess: {
    awaitingPayment: "En espera de pago",
    confirmed: "Confirmado",
    swapped: "Intercambiado",
    swapping: "Intercambiando",
    sending: "Enviando ZNX",
    sendingToken: "Enviando {token}",
    usualTime: "Esto suele tardar 5-30 minutos."
  },
  transactionStatus: {
    complete: "¡Transacción completa!",
    failed: "Transacción fallida",
    withdrawFailed: "Retiro fallido",
    successSend: "{token} se ha enviado correctamente a tu billetera.",
    errorOccurred: "Ocurrió un error al procesar la transacción.",
    viewOnExplorer: "Ver en el explorador",
    contactSupport: "Contactar soporte",
    backToWallet: "Volver a la billetera",
    withdrawComplete: "Retiro completado!",
    withdrawAmountLabel: "Monto de retiro",
    destinationAddressLabel: "Dirección de destino",
    estimatedProcessingTimeLabel: "Tiempo estimado de procesamiento",
    transactionFeeLabel: "Comisión de transacción",
    continueInWallet: "Continuar en la billetera",
    checkOnSolscan: "Ver en Solscan",
    withdrawEtaValue: "{value} minutos",
    withdrawEtaDefault: "1-2 minutos",
    swapComplete: "¡Intercambio completado!",
    swapFailed: "Intercambio fallido",
    youSendLabel: "Tú envías",
    exchangeRateLabel: "Tipo de cambio",
    youGetLabel: "Tú recibes"
  },
  play: {
    banner: {
      title: "Staking & Lotería",
      description: "Haz staking de tus tokens $ZNX para ganar recompensas. ¡Cuanto más tiempo hagas staking, mayores tus posibilidades de ganar!"
    },
    statsSmall: {
      previousJackpot: "Jackpot anterior",
      upcomingPayment: "Próximo pago",
      activeParticipants: "Participantes activos"
    },
    ctaStake: "Hacer staking y ganar",
    chipActive: "Activo",
    stats: {
      totalValueStaked: "Valor total en staking",
      activeStakers: "Stakers activos",
      currentPrizePool: "Pool de premios actual"
    },
    nextDraws: {
      title: "Próximos sorteos",
      description: "Cuenta atrás para la próxima lotería de premios. ¡No pierdas tu oportunidad!"
    },
    jackpots: {
      weekly: "JACKPOT SEMANAL",
      monthly: "JACKPOT MENSUAL",
      annual: "JACKPOT ANUAL"
    },
    time: {
      days: "Días",
      hours: "Horas",
      minutes: "Minutos"
    },
    prizeSub: "en el bote de premios",
    stakeDialog: {
      header: "Iniciar staking",
      description: "Elige cantidad y duración para máximo potencial de beneficio",
      labelAmount: "Cantidad a hacer staking (ZNX)",
      placeholderAmount: "Introduce la cantidad",
      max: "MÁX",
      infoMessage: "¡Aumenta el staking a 500 ZNX para duplicar tu beneficio potencial!",
      plan: {
        multiplier: "Multiplicador",
        labelApy: "APY fijo"
      },
      stats: {
        weeklyDistribution: "Distribución semanal",
        monthlyDistribution: "Distribución mensual",
        totalPotentialProfit: "Beneficio potencial total"
      },
      createStake: "Crear staking"
    },
    summaryRow: {
      stakeAmount: "Cantidad en staking",
      duration: "Duración",
      fixedApy: "APY fijo",
      guaranteedProfit: "Beneficio garantizado",
      additionalProfitChance: "Probabilidad de beneficio adicional"
    }
  },
  connectDialog: {
    text: "¡Conecta tu billetera para ver todos los productos disponibles!",
    button: "Conectar billetera"
  },
  profileCard: {
    hiUser: "Hola, usuario",
    copyFullAddress: "Copiar dirección completa",
    profileSettings: "Configuración del perfil"
  },
  welcomeDashboard: {
    subTitle: "Participa. Gana. Empodérate.",
    description: "¡El primer ecosistema iGaming-Fintech con RWA de casino y soluciones revolucionarias!",
    button: "Conectar billetera",
    revsharePools: {
      titleAccent: "Revshare",
      titleRest: "pools",
      description1: "El primer RWA de iGaming — Financia tráfico de casino CPA y gana un % de los ingresos de la plataforma (GGR)",
      description2: "uniéndote a los pools de RevShare de ZNX para ganancias conservadoras o de alto rendimiento.",
      cta: "Empezar a ganar"
    },
    dashboardElements: {
      invest: {
        text: "Gana cada mes con los productos Casino RWA líderes del sector",
        button: "Gana ZNX y USDC"
      },
      play: {
        text: "Mantén ZNX, gana ingresos pasivos,\ny multiplícalos en nuestros minijuegos.",
        button: ""
      },
      arena: {
        text: "Obtén beneficios de promotores que compiten por clientes en el primer reality de negocios de casino.",
        button: ""
      }
    },
    dashboardReferral: {
      boost: "Aumenta tus ganancias con",
      programName: "Programa de Referidos"
    },
    dashboardConnect: {
      subTitle: "S'engager. Gagner. S'émanciper.",
      text: "Le premier écosystème iGaming-Fintech\navec Casino RWA et des solutions révolutionnaires !"
    },
    dashboardPartners: {
      title1: "Red global.",
      title2: "Visión compartida.",
      subTitle: "Integrados con los principales socios de iGaming y fintech, aprovechamos las tecnologías blockchain y de contratos inteligentes\n para desarrollar soluciones de próxima generación."
    },
    dashboardPhotos: {
      title: "Momentos",
      subtitle: "Personas. Energía. Innovación.",
      followUs: "Síguenos para más momentos",
      texts: {
        We_brought: "Llevamos el espíritu Web3 a MAC Ereván",
        Innovation_networking: "Innovación, networking e ideas audaces — así es CPA Life Fest con Zenex",
        Zenex_at: "Zenex en BroConf — pura energía",
        Connecting_minds: "Conectando mentes en TOKEN2049",
        Game_on: "El juego continúa en SBC Summit",
        From_insights: "De las ideas a la acción — en CPA Life Fest",
        TOKEN2049_vibes: "Vibras TOKEN2049: conversaciones reales, crecimiento, energía",
        Behind_every: "Detrás de cada evento hay una historia — de ideas audaces, asociaciones y experiencias inolvidables que impulsan a la comunidad Zenex hacia adelante.",
        Bright_ideas: "Ideas brillantes, SiGMA"
      }
    }

  }
};
